import { getConfig } from '../config';

// API base URL comes from runtime /config.json (loaded in main.tsx before
// App renders). Wrapped in a function so each call reads the current value
// — keeps the surface mockable in tests via _setConfigForTest in config.ts.
function base(): string {
  return getConfig().adminApiBaseUrl;
}

let bearerToken: string | null = null;

export function setBearerToken(t: string | null): void {
  bearerToken = t;
}

export function getBearerToken(): string | null {
  return bearerToken;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers as HeadersInit | undefined);
  headers.set('content-type', 'application/json');
  if (bearerToken) headers.set('authorization', `Bearer ${bearerToken}`);

  const res = await fetch(`${base()}${path}`, { ...init, headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({})) as { error?: string; message?: string };
    throw new ApiError(
      res.status,
      body.error ?? 'unknown_error',
      body.message ?? res.statusText,
    );
  }
  if (res.status === 204) return undefined as unknown as T;
  return res.json() as Promise<T>;
}
